(() => {
  const root = window.Shopify?.routes?.root || '/';
  const STRINGS = window.DENO_STRINGS || {};
  const t = (key, vars = {}) => String(STRINGS[key] ?? key).replace(/\{\{\s*(\w+)\s*\}\}|__(\w+)__/g, (match, a, b) => vars[a || b] ?? '');
  const lang = document.documentElement.lang || 'fr';
  const money = cents => new Intl.NumberFormat(lang, { style: 'currency', currency: document.body.dataset.currency || 'EUR' }).format(Number(cents || 0) / 100);
  const normalizeSearch = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(lang).trim();
  const connectionLabels = { none: t('connection_none'), 'hdmi-usbc': t('connection_hdmi_usbc'), 'hdmi-usba': t('connection_hdmi_usba') };
  const packItems = (id, hdmiId, usbaId, connection, quantity, label) => {
    const items = [{ id, quantity, ...(connection ? { properties: { [t('prop_connection')]: connectionLabels[connection] } } : {}) }];
    if (connection === 'hdmi-usbc' || connection === 'hdmi-usba') items.push({ id: hdmiId, quantity, properties: { [t('prop_for_pack')]: label } });
    if (connection === 'hdmi-usba') items.push({ id: usbaId, quantity, properties: { [t('prop_for_pack')]: label } });
    return items;
  };
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
  const notify = (message) => {
    const toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.innerHTML = `<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 12 4 4L19 6"/></svg>${escapeHtml(message)}<button type="button" aria-label="${escapeHtml(t('close'))}">×</button>`;
    toast.hidden = false;
    toast.querySelector('button')?.addEventListener('click', () => { toast.hidden = true; });
    clearTimeout(notify.timer);
    notify.timer = setTimeout(() => { toast.hidden = true; }, 3200);
  };
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerContent = drawer?.querySelector('[data-drawer-content]');
  const checkoutInformation = document.querySelector('[data-checkout-information]')?.innerHTML || '';
  const vatNotice = document.body.dataset.vatNotice || '';
  let latestCart = null;
  let drawerTrigger = null;
  let drawerBusy = false;
  const lockPage = () => { document.body.style.overflow = drawer && !drawer.hidden || document.querySelector('[data-product-modal]:not([hidden])') ? 'hidden' : ''; };
  const getCart = async () => {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error(t('cart_load_error'));
    return response.json();
  };
  // v4.4 — Panier : jauge de livraison offerte, réassurance et produits complémentaires.
  const drawerTrust = document.querySelector('[data-drawer-trust]')?.innerHTML || '';
  const freeShippingCents = Math.round(Number(drawer?.dataset.freeShipping || 0) * Number(window.Shopify?.currency?.rate || 1));
  const freeShippingHtml = total => {
    if (!freeShippingCents) return '';
    const remaining = freeShippingCents - Number(total || 0);
    const ratio = Math.max(0, Math.min(1, Number(total || 0) / freeShippingCents));
    const label = remaining > 0 ? escapeHtml(t('free_shipping_remaining', { amount: '\u0000' })).replace('\u0000', `<strong>${money(remaining)}</strong>`) : `<strong>${escapeHtml(t('free_shipping_done'))}</strong>`;
    return `<div class="drawer-shipping${remaining > 0 ? '' : ' is-done'}"><p>${label}</p><span class="drawer-shipping__bar" aria-hidden="true"><i style="width:${Math.round(ratio * 100)}%"></i></span></div>`;
  };
  let searchImageMap = null;
  const imageForHandle = handle => {
    if (!searchImageMap) { try { searchImageMap = JSON.parse(document.querySelector('[data-search-images]')?.textContent || '{}'); } catch { searchImageMap = {}; } }
    return searchImageMap[handle] || '';
  };
  let recoRequest = 0;
  const recoCache = new Map();
  const loadRecommendations = async cart => {
    const box = drawerContent?.querySelector('[data-drawer-reco]');
    if (!box || drawer?.dataset.recommendations !== 'true' || !cart?.items?.length) return;
    const request = ++recoRequest;
    const inCart = new Set(cart.items.map(item => item.product_id));
    const sourceId = cart.items[0].product_id;
    const baseUrl = drawer.dataset.recoUrl || `${root}recommendations/products`;
    const fetchIntent = async intent => {
      const key = `${sourceId}:${intent}`;
      if (recoCache.has(key)) return recoCache.get(key);
      const response = await fetch(`${baseUrl}.json?product_id=${sourceId}&limit=8&intent=${intent}`, { headers: { Accept: 'application/json' } });
      const products = response.ok ? (await response.json()).products || [] : [];
      recoCache.set(key, products);
      return products;
    };
    try {
      let products = await fetchIntent('complementary');
      if (!products.filter(product => !inCart.has(product.id)).length) products = await fetchIntent('related');
      if (request !== recoRequest) return;
      const picks = products.filter(product => !inCart.has(product.id) && product.available && product.variants?.some(variant => variant.available)).slice(0, 2);
      if (!picks.length) return;
      box.innerHTML = `<span class="drawer-reco__label">${escapeHtml(t('reco_label'))}</span><ul>${picks.map(product => {
        const variant = product.variants.find(item => item.available);
        const image = imageForHandle(product.handle) || product.featured_image || '';
        return `<li class="drawer-reco__item"><a href="${escapeHtml(product.url)}" class="drawer-reco__image">${image ? `<img src="${escapeHtml(image)}" alt="" width="96" height="72" loading="lazy">` : ''}</a><a href="${escapeHtml(product.url)}" class="drawer-reco__text"><small>${escapeHtml(product.vendor || '')}</small><strong>${escapeHtml(product.title)}</strong><span>${money(variant.price)}</span></a><button type="button" class="drawer-reco__add" data-reco-add="${variant.id}" data-reco-title="${escapeHtml(product.title)}" aria-label="${escapeHtml(t('reco_add', { title: product.title }))}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button></li>`;
      }).join('')}</ul>`;
      box.hidden = false;
    } catch { /* Les suggestions restent facultatives. */ }
  };
  const renderCart = cart => {
    latestCart = cart;
    document.querySelectorAll('[data-cart-count], [data-drawer-count]').forEach(node => { node.textContent = cart.item_count; });
    if (!drawerContent) return;
    if (!cart.items.length) {
      drawerContent.innerHTML = `<div class="cart-empty"><span>✳</span><h3>${escapeHtml(t('cart_empty_title'))}</h3><p>${escapeHtml(t('cart_empty_text'))}</p><button class="button button-dark" type="button" data-cart-close>${escapeHtml(t('cart_empty_cta'))} →</button></div>`;
      return;
    }
    const lines = cart.items.map(item => {
      const properties = Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && value).map(([key, value]) => `<span class="cart-line-detail">${escapeHtml(key)} : ${escapeHtml(value)}</span>`).join('');
      const components = (item.item_components || []).map(component => `<span class="cart-line-detail">${component.quantity} × ${escapeHtml(component.product_title || component.product?.title || component.title)}</span>`).join('');
      return `<div class="cart-item"><a href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ''}</a><div><span class="cart-brand-text">${escapeHtml(item.vendor)}</span><strong>${escapeHtml(item.product_title)}${item.variant_title && item.variant_title !== 'Default Title' ? ` · ${escapeHtml(item.variant_title)}` : ''}</strong>${properties}${components}<small>${money(item.final_line_price)}</small><div class="quantity"><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity - 1}" aria-label="${escapeHtml(t('remove_one', { title: item.product_title }))}">−</button><b>${item.quantity}</b><button type="button" data-cart-change="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="${escapeHtml(t('add_one', { title: item.product_title }))}">+</button></div></div></div>`;
    }).join('');
    drawerContent.innerHTML = `${freeShippingHtml(cart.total_price)}<div class="cart-list">${lines}<div class="drawer-reco" data-drawer-reco hidden></div></div><div class="drawer-foot"><div class="subtotal"><span>${escapeHtml(t('subtotal'))}</span><strong>${money(cart.total_price)}</strong></div>${vatNotice ? `<small class="cart-vat-notice">${escapeHtml(vatNotice)}</small>` : ''}<p>${escapeHtml(t('shipping_note'))}</p>${STRINGS.import_notice ? `<p class="import-notice">${escapeHtml(STRINGS.import_notice)}</p>` : ''}${checkoutInformation}<form action="${escapeHtml(root)}cart" method="post"><button class="button button-dark checkout-button" name="checkout" type="submit">${escapeHtml(t('checkout'))} →</button></form>${drawerTrust}<button class="continue-button" type="button" data-cart-close>${escapeHtml(t('continue'))}</button></div>`;
    loadRecommendations(cart);
  };
  const openDrawer = async (cart = null) => {
    if (!drawer) return;
    drawerTrigger = document.activeElement;
    drawer.hidden = false;
    lockPage();
    drawer.querySelector('.cart-drawer')?.focus();
    try { renderCart(cart?.items ? cart : await getCart()); } catch (error) { if (drawerContent) drawerContent.innerHTML = `<p class="form-error" role="alert">${escapeHtml(error.message)}</p><a href="${escapeHtml(root)}cart">${escapeHtml(t('open_cart_page'))}</a>`; }
  };
  const closeDrawer = () => { if (!drawer || drawer.hidden) return; drawer.hidden = true; lockPage(); drawerTrigger?.focus(); };
  // v4.5 — Ajout au panier : la photo s'envole vers le panier, le compteur rebondit.
  const motionOK = () => !matchMedia('(prefers-reduced-motion: reduce)').matches && !document.body.classList.contains('motion-off');
  let lastAddSource = null;
  document.addEventListener('pointerdown', event => { lastAddSource = event.target.closest('[data-product-card], [data-product-page], [data-pack-card], .drawer-reco__item'); }, true);
  const bumpBag = () => {
    document.querySelectorAll('.bag-button').forEach(bag => { bag.classList.remove('is-bump'); void bag.offsetWidth; bag.classList.add('is-bump'); });
  };
  const celebrateAdd = drawerWillOpen => {
    const bag = [...document.querySelectorAll('.bag-button')].find(node => node.offsetParent !== null);
    const image = lastAddSource?.querySelector('img.pv-img, [data-main-product-image], .pack-art, img');
    lastAddSource = null;
    if (!bag || !image || drawerWillOpen || !motionOK() || !image.animate) { bumpBag(); return; }
    const from = image.getBoundingClientRect();
    const to = bag.getBoundingClientRect();
    if (!from.width || from.bottom < 0 || from.top > innerHeight) { bumpBag(); return; }
    const ghost = image.cloneNode(false);
    ghost.removeAttribute('style'); ghost.removeAttribute('srcset'); ghost.removeAttribute('loading'); ghost.removeAttribute('data-main-product-image');
    ghost.className = 'fly-ghost';
    Object.assign(ghost.style, { left: `${from.left}px`, top: `${from.top}px`, width: `${from.width}px`, height: `${from.height}px` });
    document.body.appendChild(ghost);
    const dx = to.left + to.width / 2 - (from.left + from.width / 2);
    const dy = to.top + to.height / 2 - (from.top + from.height / 2);
    const scale = Math.max(0.08, 34 / from.width);
    ghost.animate([
      { transform: 'translate(0, 0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * 0.55}px, ${dy * 0.35 - 60}px) scale(${(1 + scale) / 2.4})`, opacity: 0.95, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, opacity: 0.2 }
    ], { duration: 760, easing: 'cubic-bezier(.55,0,.25,1)' }).finished.then(() => { ghost.remove(); bumpBag(); }).catch(() => ghost.remove());
  };
  const addItems = async (items, label, showDrawer = true) => {
    const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
    if (!response.ok) { const data = await response.json().catch(() => ({})); throw new Error(data.description || data.message || t('add_error')); }
    const cart = await getCart();
    renderCart(cart);
    notify(t('added', { title: label }));
    celebrateAdd(showDrawer);
    if (showDrawer) await openDrawer(cart);
  };
  document.querySelectorAll('[data-cart-open]').forEach(button => button.addEventListener('click', openDrawer));
  drawer?.addEventListener('click', async event => {
    if (event.target === drawer || event.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const recoAdd = event.target.closest('[data-reco-add]');
    if (recoAdd && !drawerBusy) {
      recoAdd.disabled = true;
      try { await addItems([{ id: Number(recoAdd.dataset.recoAdd), quantity: 1 }], recoAdd.dataset.recoTitle || t('product'), false); }
      catch (error) { notify(error.message); recoAdd.disabled = false; }
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (!change || drawerBusy) return;
    drawerBusy = true;
    drawer.setAttribute('aria-busy', 'true');
    drawer.querySelectorAll('[data-cart-change]').forEach(button => { button.disabled = true; });
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }) });
      if (!response.ok) throw new Error(t('quantity_error'));
      renderCart(await response.json());
    } catch (error) { notify(error.message); }
    finally { drawerBusy = false; drawer.removeAttribute('aria-busy'); drawer.querySelectorAll('[data-cart-change]').forEach(button => { button.disabled = false; }); }
  });

  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.getElementById('MobileNav');
  const setMenu = open => {
    if (!menuButton || !mobileNav) return;
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? t('menu_close') : t('menu_open'));
    mobileNav.hidden = !open;
    menuButton.innerHTML = open ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>';
  };
  menuButton?.addEventListener('click', () => setMenu(menuButton.getAttribute('aria-expanded') !== 'true'));
  mobileNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));

  const slider = document.querySelector('[data-hero-slider]');
  if (slider) {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    const counters = [...slider.querySelectorAll('[data-hero-count]')];
    const pauseButtons = [...slider.querySelectorAll('[data-hero-pause]')];
    const pauseIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M9 5v14M15 5v14"/></svg>';
    const playIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="m8 5 11 7-11 7V5Z"/></svg>';
    let index = 0;
    let timer;
    let paused = false;
    let resumeWhileFocused = false;
    // Reserve the tallest copy slot before positioning the shared navigation.
    // Measure natural content, not the height already reserved by this variable.
    const sizeCopySlot = () => {
      if (!slider.clientWidth) return;
      slider.classList.add('is-measuring');
      try {
        let height = matchMedia('(max-width: 760px)').matches ? 0 : 615;
        slides.forEach(slide => {
          const copy = slide.querySelector('[data-hero-copy]');
          const content = copy?.querySelector('[data-hero-content]');
          if (!content) return;
          const style = getComputedStyle(copy);
          height = Math.max(height, content.getBoundingClientRect().height + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
        });
        slider.style.setProperty('--hero-copy-height', `${Math.ceil(height)}px`);
      } finally {
        slider.classList.remove('is-measuring');
      }
    };
    let layoutFrame;
    const queueLayout = () => {
      cancelAnimationFrame(layoutFrame);
      layoutFrame = requestAnimationFrame(sizeCopySlot);
    };
    let measuredWidth = slider.clientWidth;
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => {
        const width = slider.clientWidth;
        if (width !== measuredWidth) { measuredWidth = width; queueLayout(); }
      }).observe(slider);
    } else {
      window.addEventListener('resize', queueLayout);
    }
    document.fonts?.ready.then(queueLayout);
    document.fonts?.addEventListener('loadingdone', queueLayout);
    sizeCopySlot();
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', String(i !== index)); });
      dots.forEach(dot => { const active = Number(dot.dataset.heroDot) === index; dot.classList.toggle('active', active); if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      counters.forEach(counter => { counter.innerHTML = `0${index + 1} <span>/</span> 0${slides.length}`; });
      slider.dataset.activeSlide = slides[index]?.classList.contains('hero--studio') ? 'studio' : slides[index]?.classList.contains('hero--instagram') ? 'instagram' : 'shop';
    };
    const stop = () => { if (timer) clearInterval(timer); };
    const start = () => { stop(); if (!paused && !document.hidden && (!slider.matches(':focus-within') || resumeWhileFocused) && slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => show(index + 1), 7000); };
    const syncPause = () => pauseButtons.forEach(button => { button.setAttribute('aria-pressed', String(paused)); button.setAttribute('aria-label', paused ? t('slider_resume') : t('slider_pause')); button.innerHTML = paused ? playIcon : pauseIcon; });
    pauseButtons.forEach(button => button.addEventListener('click', event => { event.stopPropagation(); paused = !paused; resumeWhileFocused = !paused; syncPause(); if (paused) stop(); else start(); }));
    slider.querySelectorAll('[data-hero-prev]').forEach(button => button.addEventListener('click', () => { show(index - 1); start(); }));
    slider.querySelectorAll('[data-hero-next]').forEach(button => button.addEventListener('click', () => { show(index + 1); start(); }));
    dots.forEach(dot => dot.addEventListener('click', () => {
      show(Number(dot.dataset.heroDot));
      start();
    }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('focusin', () => { resumeWhileFocused = false; stop(); });
    slider.addEventListener('focusout', event => { if (!slider.contains(event.relatedTarget)) { resumeWhileFocused = false; start(); } });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
    show(0);
    start();
  }

  document.querySelectorAll('[data-pack-card]').forEach(card => {
    const select = card.querySelector('[data-pack-connection]');
    const price = card.querySelector('[data-pack-price]');
    const help = card.querySelector('[data-pack-help]');
    const errorBox = card.querySelector('[data-pack-error]');
    const addButton = card.querySelector('[data-pack-add]');
    const baseReady = Number(card.dataset.baseId) > 0;
    if (select) select.disabled = !baseReady || addButton?.disabled;
    const refresh = () => {
      let cents = Number(card.dataset.basePrice || 0);
      if (select?.value === 'hdmi-usbc' || select?.value === 'hdmi-usba') cents += Number(card.dataset.hdmiPrice || 0);
      if (select?.value === 'hdmi-usba') cents += Number(card.dataset.usbaPrice || 0);
      if (price) price.textContent = baseReady ? money(cents) : t('unavailable');
      if (help) help.textContent = select?.value === 'hdmi-usbc' ? t('pack_help_hdmi_usbc') : select?.value === 'hdmi-usba' ? t('pack_help_hdmi_usba') : t('pack_help_none');
    };
    select?.addEventListener('change', refresh);
    card.querySelector('[data-pack-add]')?.addEventListener('click', async event => {
      const baseId = Number(card.dataset.baseId || 0);
      const hdmiId = Number(card.dataset.hdmiId || 0);
      const usbaId = Number(card.dataset.usbaId || 0);
      if (!baseId || ((select?.value === 'hdmi-usbc' || select?.value === 'hdmi-usba') && !hdmiId) || (select?.value === 'hdmi-usba' && !usbaId)) {
        if (errorBox) { errorBox.textContent = t('pack_unavailable'); errorBox.hidden = false; }
        return;
      }
      const button = event.currentTarget;
      if (button.disabled) return;
      const items = packItems(baseId, hdmiId, usbaId, select?.value, 1, card.dataset.packName);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (errorBox) errorBox.hidden = true;
      try { await addItems(items, t('pack', { title: card.dataset.packName })); }
      catch (error) { if (errorBox) { errorBox.textContent = error.message; errorBox.hidden = false; } }
      finally { button.disabled = false; button.removeAttribute('aria-busy'); }
    });
    refresh();
  });

  const catalog = document.querySelector('[data-home-catalog]');
  if (catalog) {
    const grid = catalog.querySelector('[data-catalog-grid]');
    const cards = [...catalog.querySelectorAll('[data-product-card]')];
    const order = new Map(cards.map((card, i) => [card, i]));
    const selected = ['wacom-movink-13', 'logitech-mx-creative-console', 'benq-sw272u', 'huion-kamvas-16-gen-3', 'benq-screenbar-halo-2', 'samsung-portable-ssd-t9-2tb'];
    const selectionOrder = new Map(selected.map((handle, i) => [handle, i]));
    const search = catalog.querySelector('[data-catalog-search]');
    const sort = catalog.querySelector('[data-catalog-sort]');
    let category = 'selection';
    catalog.querySelectorAll('[data-category-count]').forEach(node => { node.textContent = node.dataset.categoryCount === 'selection' ? cards.filter(card => card.dataset.selection).length : node.dataset.categoryCount === 'all' ? cards.length : cards.filter(card => card.dataset.category === node.dataset.categoryCount).length; });
    const render = () => {
      const q = normalizeSearch(search?.value);
      const chosen = cards.filter(card => (q ? category === 'selection' || category === 'all' || card.dataset.category === category : category === 'all' || category === 'selection' && card.dataset.selection || card.dataset.category === category) && (!q || normalizeSearch(card.dataset.search).includes(q)));
      const mode = sort?.value || 'selection';
      chosen.sort((a, b) => mode === 'price-asc' ? Number(a.dataset.price) - Number(b.dataset.price) : mode === 'price-desc' ? Number(b.dataset.price) - Number(a.dataset.price) : mode === 'brand' ? `${a.dataset.vendor} ${a.dataset.title}`.localeCompare(`${b.dataset.vendor} ${b.dataset.title}`, lang) : category === 'selection' && !q ? (selectionOrder.get(a.dataset.handle) ?? 99) - (selectionOrder.get(b.dataset.handle) ?? 99) : order.get(a) - order.get(b));
      cards.forEach(card => { card.hidden = !chosen.includes(card); });
      chosen.forEach(card => grid.append(card));
      catalog.querySelector('[data-result-count]').textContent = t('catalog_count', { shown: chosen.length, total: cards.length });
      catalog.querySelector('[data-catalog-empty]').hidden = chosen.length > 0;
      catalog.querySelector('[data-catalog-title]').textContent = category === 'selection' && !q ? t('catalog_selection') : category === 'all' || category === 'selection' ? t('catalog_all') : (catalog.querySelector(`[data-category-filter="${CSS.escape(category)}"] span`)?.textContent || category);
      catalog.querySelectorAll('[data-category-filter]').forEach(button => { const active = button.dataset.categoryFilter === category; button.classList.toggle('active', active); button.setAttribute('aria-pressed', String(active)); });
    };
    catalog.querySelectorAll('[data-category-filter]').forEach(button => button.addEventListener('click', () => { category = button.dataset.categoryFilter; if (category === 'selection') { search.value = ''; sort.value = 'selection'; } render(); }));
    search?.addEventListener('input', render);
    sort?.addEventListener('change', render);
    catalog.querySelector('[data-catalog-reset]')?.addEventListener('click', () => { category = 'all'; search.value = ''; sort.value = 'selection'; render(); });
    render();
  }

  let storedFavorites = [];
  try { storedFavorites = JSON.parse(localStorage.getItem('denomania-favs') || '[]'); } catch { /* Le catalogue reste utilisable même si le stockage local est invalide. */ }
  const favorites = new Set(Array.isArray(storedFavorites) ? storedFavorites : []);
  const favoriteButtons = [...document.querySelectorAll('[data-favorite]')];
  const updateFavoriteButton = button => { const on = favorites.has(button.dataset.favorite); button.classList.toggle('on', on); button.setAttribute('aria-pressed', String(on)); button.setAttribute('aria-label', on ? t('fav_remove') : t('fav_add')); };
  const refreshFavorites = () => {
    favoriteButtons.forEach(updateFavoriteButton);
    document.querySelectorAll('[data-fav-count]').forEach(node => { node.textContent = favorites.size; node.hidden = favorites.size === 0; });
    document.dispatchEvent(new CustomEvent('denomania:favorites'));
  };
  favoriteButtons.forEach(button => button.addEventListener('click', event => {
    event.stopPropagation();
    favorites.has(button.dataset.favorite) ? favorites.delete(button.dataset.favorite) : favorites.add(button.dataset.favorite);
    try { localStorage.setItem('denomania-favs', JSON.stringify([...favorites])); } catch { /* Le favori reste visible pour cette visite. */ }
    refreshFavorites();
  }));
  const favoritesPage = document.querySelector('[data-favorites-page]');
  if (favoritesPage) {
    const favoriteCards = [...favoritesPage.querySelectorAll('[data-product-card]')];
    const empty = favoritesPage.querySelector('[data-favorites-empty]');
    const count = favoritesPage.querySelector('[data-favorites-count]');
    document.addEventListener('denomania:favorites', () => {
      let shown = 0;
      favoriteCards.forEach(card => { const on = favorites.has(card.dataset.handle); card.hidden = !on; if (on) shown += 1; });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown ? t(shown > 1 ? 'favorites_count_other' : 'favorites_count_one', { number: shown }) : '';
    });
  }
  refreshFavorites();
  const modal = document.querySelector('[data-product-modal]');
  let modalCard = null;
  let modalTrigger = null;
  const closeModal = (restoreFocus = true) => { if (!modal || modal.hidden) return; modal.hidden = true; lockPage(); if (restoreFocus) modalTrigger?.focus(); };
  const openModal = (card, trigger) => {
    if (!modal || !card) return;
    modalCard = card;
    modalTrigger = trigger;
    const image = modal.querySelector('[data-modal-image]');
    image.src = card.dataset.image || '';
    image.alt = card.dataset.fullTitle || '';
    modal.querySelector('[data-modal-brand]').innerHTML = card.querySelector('.product-meta .brand-logo')?.outerHTML || escapeHtml(card.dataset.vendor);
    modal.querySelector('[data-modal-category]').textContent = card.dataset.category || '';
    modal.querySelector('[data-modal-title]').textContent = card.dataset.title || '';
    modal.querySelector('[data-modal-price]').textContent = money(card.dataset.price);
    const modalAdd = modal.querySelector('[data-modal-add]');
    modalAdd.disabled = card.dataset.available !== 'true';
    modalAdd.textContent = card.dataset.available !== 'true' ? t('sold_out') : card.dataset.requiresConfiguration === 'true' ? `${t('choose_options')} ↗` : `${t('add_to_cart')} +`;
    modal.querySelector('[data-modal-link]').href = card.dataset.url || '#';
    const detail = document.createElement('div');
    detail.innerHTML = card.querySelector('[data-card-detail]')?.innerHTML || '';
    modal.querySelector('[data-modal-description]').textContent = detail.querySelector('p')?.textContent || detail.textContent || '';
    modal.querySelector('[data-modal-specs]').innerHTML = [...detail.querySelectorAll('li')].slice(0, 4).map(li => `<span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 12 4 4L19 6"/></svg>${escapeHtml(li.textContent)}</span>`).join('');
    modal.hidden = false;
    lockPage();
    modal.querySelector('.product-modal')?.focus();
  };
  document.querySelectorAll('[data-quick-view]').forEach(trigger => {
    trigger.addEventListener('click', () => openModal(trigger.closest('[data-product-card]'), trigger));
  });
  modal?.addEventListener('click', event => { if (event.target === modal || event.target.closest('[data-modal-close]')) closeModal(); });
  modal?.querySelector('[data-modal-add]')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    const card = modalCard;
    if (!card || button.disabled) return;
    if (card.dataset.requiresConfiguration === 'true') { window.location.assign(card.dataset.url); return; }
    const id = Number(modalCard?.dataset.variantId || 0);
    if (!id) return;
    button.disabled = true;
    try { await addItems([{ id, quantity: 1 }], card.dataset.fullTitle); closeModal(false); drawerTrigger = modalTrigger; }
    catch (error) { notify(error.message); }
    finally { button.disabled = card.dataset.available !== 'true'; }
  });
  document.querySelectorAll('[data-quick-add]').forEach(button => button.addEventListener('click', async event => {
    const card = event.currentTarget.closest('[data-product-card]');
    if (button.disabled || !card) return;
    if (card.dataset.requiresConfiguration === 'true') { window.location.assign(card.dataset.url); return; }
    const id = Number(card?.dataset.variantId || 0);
    if (!id) return;
    button.disabled = true;
    try { await addItems([{ id, quantity: 1 }], card.dataset.fullTitle, false); }
    catch (error) { notify(error.message); }
    finally { button.disabled = false; }
  }));
  document.querySelectorAll('[data-product-card]').forEach(card => { const price = card.querySelector('[data-card-price]'); if (price) price.textContent = money(card.dataset.price); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') { if (drawer && !drawer.hidden) closeDrawer(); else closeModal(); setMenu(false); }
    if (event.key !== 'Tab') return;
    const activeDialog = drawer && !drawer.hidden ? drawer : modal && !modal.hidden ? modal : null;
    if (!activeDialog) return;
    const focusable = [...activeDialog.querySelectorAll('a[href],button:not(:disabled),input:not([type="hidden"]),select,textarea,[tabindex="0"]')].filter(el => !el.closest('[hidden]'));
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  document.querySelector('[data-form-result]')?.focus();

  document.querySelectorAll('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form?.submit()));
  const mainImage = document.querySelector('[data-main-product-image]');
  document.querySelectorAll('[data-image-thumb]').forEach(button => button.addEventListener('click', () => { if (!mainImage) return; if (button.dataset.imageSrcset) mainImage.srcset = button.dataset.imageSrcset; else mainImage.removeAttribute('srcset'); mainImage.src = button.dataset.imageSrc; mainImage.alt = button.dataset.imageAlt || ''; document.querySelectorAll('[data-image-thumb]').forEach(thumb => thumb.classList.toggle('is-active', thumb === button)); }));
  const productPage = document.querySelector('[data-product-page]');
  if (productPage) {
    const form = productPage.querySelector('.den-product-form');
    const variant = form?.querySelector('[data-variant-select]');
    const cable = form?.querySelector('[data-cable-select]');
    const price = productPage.querySelector('[data-product-price]');
    const add = form?.querySelector('[data-add-button]');
    const errorBox = form?.querySelector('[data-cart-error]');
    const help = form?.querySelector('[data-cable-help]');
    let submitting = false;
    const selectedVariant = () => variant?.selectedOptions?.[0] || variant;
    const refresh = () => {
      const option = selectedVariant();
      let cents = Number(option?.dataset.price || 0);
      if (cable?.value === 'hdmi-usbc' || cable?.value === 'hdmi-usba') cents += Number(cable.dataset.hdmiPrice || 0);
      if (cable?.value === 'hdmi-usba') cents += Number(cable.dataset.usbaPrice || 0);
      if (price) price.textContent = money(cents);
      document.querySelectorAll('[data-sticky-price]').forEach(node => { node.textContent = money(cents); });
      if (add) { add.disabled = submitting || option?.dataset.available !== 'true'; add.textContent = submitting ? t('adding') : option?.dataset.available === 'true' ? `${t('add_to_cart')} ↗` : t('sold_out'); }
      const acceleratedCheckout = form?.querySelector('.accelerated-checkout');
      if (acceleratedCheckout) acceleratedCheckout.hidden = option?.dataset.available !== 'true';
      if (help) help.textContent = cable?.value === 'hdmi-usbc' ? t('product_help_hdmi_usbc') : cable?.value === 'hdmi-usba' ? t('product_help_hdmi_usba') : t('product_help_none');
    };
    variant?.addEventListener('change', () => {
      refresh();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.value);
      window.history.replaceState({}, '', url);
    });
    cable?.addEventListener('change', refresh);
    refresh();
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting || !form.reportValidity()) return;
      const id = Number(variant?.value || 0);
      const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
      const hdmiId = Number(cable?.dataset.hdmiId || 0);
      const usbaId = Number(cable?.dataset.usbaId || 0);
      const items = packItems(id, hdmiId, usbaId, cable?.value, quantity, productPage.querySelector('h1')?.textContent || t('pack', { title: '' }).trim());
      if (!id || items.some(item => !item.id)) { if (errorBox) { errorBox.textContent = t('product_unavailable'); errorBox.hidden = false; } return; }
      if (!Number.isInteger(quantity) || quantity < 1 || selectedVariant()?.dataset.available !== 'true') return;
      submitting = true;
      form.setAttribute('aria-busy', 'true');
      refresh();
      if (errorBox) errorBox.hidden = true;
      try { await addItems(items, productPage.querySelector('h1')?.textContent || t('product')); }
      catch (error) { if (errorBox) { errorBox.textContent = error.message; errorBox.hidden = false; } }
      finally { submitting = false; form.removeAttribute('aria-busy'); refresh(); }
    });
  }

  // Bandeau d'annonces : un message à la fois sur téléphone.
  const announcement = document.querySelector('[data-announcement]');
  if (announcement) {
    const items = [...announcement.querySelectorAll('[data-announcement-item]')];
    const compact = matchMedia('(max-width: 989px)');
    const calm = matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let rotation;
    const showItem = next => { current = (next + items.length) % items.length; items.forEach((item, i) => item.classList.toggle('is-active', i === current)); };
    const stopRotation = () => { if (rotation) clearInterval(rotation); rotation = null; };
    const startRotation = () => { stopRotation(); if (items.length > 1 && compact.matches && !calm.matches) rotation = setInterval(() => showItem(current + 1), 4000); };
    announcement.addEventListener('mouseenter', stopRotation);
    announcement.addEventListener('mouseleave', startRotation);
    announcement.addEventListener('focusin', stopRotation);
    announcement.addEventListener('focusout', startRotation);
    compact.addEventListener?.('change', () => { showItem(0); startRotation(); });
    startRotation();
  }

  // Quantité : boutons − et +.
  document.querySelectorAll('[data-qty-step]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    const next = Math.max(Number(input.min || 1), (Number(input.value) || 1) + Number(button.dataset.qtyStep));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  // Barre d'achat fixe : sur ordinateur, visible quand le bouton principal est passé ;
  // sur mobile, visible dès l'arrivée tant que le bouton principal n'est pas à l'écran.
  const sticky = document.querySelector('[data-pdp-sticky]');
  const mainAdd = document.querySelector('[data-product-page] [data-add-button]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    const stickyAdd = sticky.querySelector('[data-sticky-add]');
    const mobile = window.matchMedia('(max-width: 760px)');
    const mainForm = mainAdd.closest('form');
    if (stickyAdd && mainForm?.querySelector('[data-cable-select]') && !mainAdd.disabled) stickyAdd.textContent = t('choose_connection');
    let lastEntry = null;
    const update = () => {
      if (!lastEntry) return;
      const show = !lastEntry.isIntersecting && (mobile.matches || lastEntry.boundingClientRect.top < 0);
      sticky.hidden = !show;
      document.body.classList.toggle('has-pdp-sticky', show);
    };
    new IntersectionObserver(([entry]) => { lastEntry = entry; update(); }).observe(mainAdd);
    mobile.addEventListener?.('change', update);
    stickyAdd?.addEventListener('click', () => {
      const form = mainAdd.closest('form');
      if (!form || mainAdd.disabled) { mainAdd.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (form.querySelector('[data-cable-select]')) { mainAdd.scrollIntoView({ behavior: 'smooth', block: 'center' }); form.querySelector('[data-cable-select]').focus({ preventScroll: true }); return; }
      form.requestSubmit ? form.requestSubmit(mainAdd) : mainAdd.click();
    });
    new MutationObserver(() => { if (stickyAdd) { stickyAdd.disabled = mainAdd.disabled; } }).observe(mainAdd, { attributes: true, attributeFilter: ['disabled'] });
  }

  // Rétractation : horodatage de la déclaration et récapitulatif après envoi.
  const withdrawalForm = document.querySelector('[data-withdrawal-form]');
  if (withdrawalForm) {
    const stamp = withdrawalForm.querySelector('[data-withdrawal-timestamp]');
    withdrawalForm.addEventListener('submit', () => {
      const now = new Date();
      const label = now.toLocaleString('fr-FR', { dateStyle: 'full', timeStyle: 'medium' });
      if (stamp) stamp.value = `${label} (${now.toISOString()})`;
      const data = {};
      new FormData(withdrawalForm).forEach((value, key) => {
        const match = key.match(/^contact\[(.+)\]$/);
        if (match && value && !['Objet', 'body'].includes(match[1])) data[match[1]] = String(value);
      });
      try { sessionStorage.setItem('denomania-withdrawal', JSON.stringify(data)); } catch { /* Le récapitulatif reste facultatif. */ }
    });
    const recap = withdrawalForm.querySelector('[data-withdrawal-recap]');
    if (recap) {
      let data = null;
      try { data = JSON.parse(sessionStorage.getItem('denomania-withdrawal') || 'null'); } catch { data = null; }
      const labels = { name: 'Nom', email: 'E-mail de confirmation' };
      if (data) {
        recap.innerHTML = Object.entries(data).map(([key, value]) => `<div><dt>${escapeHtml(labels[key] || key)}</dt><dd>${escapeHtml(value)}</dd></div>`).join('');
        recap.hidden = false;
      }
    }
    withdrawalForm.querySelector('[data-withdrawal-print]')?.addEventListener('click', () => window.print());
  }
  // v5.8.8 : la carte postale de la page contact est oblitérée à la date du jour du visiteur.
  document.querySelectorAll('[data-postmark-date]').forEach((el) => {
    const d = new Date();
    el.textContent = [d.getDate(), d.getMonth() + 1, d.getFullYear() % 100].map((n) => String(n).padStart(2, '0')).join('.');
  });
  // v4.3 — Recherche avec suggestions instantanées (loupe de l'en-tête).
  const searchOverlay = document.querySelector('[data-search-overlay]');
  if (searchOverlay) {
    const searchPanel = searchOverlay.querySelector('.search-panel');
    const searchInput = searchOverlay.querySelector('[data-search-input]');
    const searchResults = searchOverlay.querySelector('[data-search-results]');
    const searchStart = searchOverlay.querySelector('[data-search-start]')?.outerHTML || '';
    let searchImages = {};
    try { searchImages = JSON.parse(searchOverlay.querySelector('[data-search-images]')?.textContent || '{}'); } catch { searchImages = {}; }
    let searchTrigger = null;
    let searchTimer = null;
    let searchController = null;
    const openSearch = () => {
      searchTrigger = document.activeElement;
      setMenu(false);
      searchOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => searchInput?.focus());
    };
    const closeSearch = () => {
      if (searchOverlay.hidden) return;
      searchOverlay.hidden = true;
      lockPage();
      searchTrigger?.focus();
    };
    const priceFromSuggest = value => {
      const number = Number(String(value || '0').replace(',', '.'));
      return Number.isFinite(number) ? money(Math.round(number * 100)) : '';
    };
    const renderSuggestions = (query, products) => {
      if (!products.length) {
        searchResults.innerHTML = `<p class="search-panel__empty">${escapeHtml(t('search_empty', { query }))}</p>${searchStart}`;
        return;
      }
      const items = products.map(product => {
        const image = searchImages[product.handle] || product.featured_image?.url || product.image || '';
        return `<li><a class="search-hit" href="${escapeHtml(product.url)}"><span class="search-hit__image">${image ? `<img src="${escapeHtml(image)}" alt="" width="96" height="72" loading="lazy">` : ''}</span><span class="search-hit__text"><small>${escapeHtml(product.vendor || '')}</small><strong>${escapeHtml(product.title)}</strong></span><b>${priceFromSuggest(product.price)}</b></a></li>`;
      }).join('');
      searchResults.innerHTML = `<span class="search-panel__label">${escapeHtml(t('search_products'))}</span><ul class="search-panel__hits">${items}</ul><a class="search-panel__all" href="${escapeHtml(root)}search?type=product&q=${encodeURIComponent(query)}">${escapeHtml(t('search_all', { query }))} →</a>`;
    };
    const runSearch = async () => {
      const query = (searchInput?.value || '').trim();
      if (query.length < 2) { searchResults.innerHTML = searchStart; return; }
      searchController?.abort();
      searchController = new AbortController();
      try {
        const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { signal: searchController.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error();
        const data = await response.json();
        renderSuggestions(query, data?.resources?.results?.products || []);
      } catch (error) {
        if (error.name !== 'AbortError') searchResults.innerHTML = `<a class="search-panel__all" href="${escapeHtml(root)}search?type=product&q=${encodeURIComponent(query)}">${escapeHtml(t('search_fallback', { query }))} →</a>`;
      }
    };
    document.querySelectorAll('[data-search-action]').forEach(button => button.addEventListener('click', openSearch));
    searchOverlay.querySelector('[data-search-close]')?.addEventListener('click', closeSearch);
    searchOverlay.addEventListener('click', event => { if (event.target === searchOverlay) closeSearch(); });
    searchInput?.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(runSearch, 180); });
    document.addEventListener('keydown', event => {
      if (searchOverlay.hidden) {
        if (event.key === '/' && !event.target.closest('input, textarea, select, [contenteditable]')) { event.preventDefault(); openSearch(); }
        return;
      }
      if (event.key === 'Escape') { event.preventDefault(); closeSearch(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...searchPanel.querySelectorAll('a[href],button:not(:disabled),input:not([type="hidden"])')];
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  // v4.3 — Agrandissement des photos sur la fiche produit.
  const zoomDialog = document.querySelector('[data-zoom-dialog]');
  if (zoomDialog && typeof zoomDialog.showModal === 'function') {
    const slides = [...zoomDialog.querySelectorAll('[data-zoom-slide]')];
    const counter = zoomDialog.querySelector('[data-zoom-count]');
    let current = 0;
    const showSlide = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
    };
    const activeThumbIndex = () => Number(document.querySelector('[data-image-thumb].is-active')?.dataset.zoomIndex || 0);
    const openZoom = () => { showSlide(activeThumbIndex()); zoomDialog.showModal(); };
    document.querySelectorAll('[data-zoom-open]').forEach(button => button.addEventListener('click', openZoom));
    mainImage?.addEventListener('click', openZoom);
    mainImage?.classList.add('is-zoomable');
    zoomDialog.querySelector('[data-zoom-close]')?.addEventListener('click', () => zoomDialog.close());
    zoomDialog.querySelector('[data-zoom-prev]')?.addEventListener('click', () => showSlide(current - 1));
    zoomDialog.querySelector('[data-zoom-next]')?.addEventListener('click', () => showSlide(current + 1));
    zoomDialog.addEventListener('click', event => { if (event.target === zoomDialog) zoomDialog.close(); });
    zoomDialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') showSlide(current - 1);
      if (event.key === 'ArrowRight') showSlide(current + 1);
    });
  }
  // v4.4 — Date d'expédition prévue (jours ouvrés, hors week-ends et jours fériés français).
  document.querySelectorAll('[data-ship-estimate]').forEach(node => {
    const days = Number(node.dataset.shipDays || 0);
    const text = node.querySelector('[data-ship-text]');
    if (!days || !text) return;
    const easter = year => { const a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1; return new Date(year, month - 1, day); };
    const holidays = year => { const e = easter(year); const shift = n => { const d = new Date(e); d.setDate(d.getDate() + n); return `${d.getMonth() + 1}-${d.getDate()}`; }; return new Set(['1-1', '5-1', '5-8', '7-14', '8-15', '11-1', '11-11', '12-25', shift(1), shift(39), shift(50)]); };
    const isWorkingDay = date => { const day = date.getDay(); return day !== 0 && day !== 6 && !holidays(date.getFullYear()).has(`${date.getMonth() + 1}-${date.getDate()}`); };
    const date = new Date();
    let added = 0;
    while (added < days) { date.setDate(date.getDate() + 1); if (isWorkingDay(date)) added += 1; }
    const label = date.toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'long' });
    text.innerHTML = escapeHtml(t('ship_estimate', { date: '\u0000' })).replace('\u0000', `<strong>${escapeHtml(label)}</strong>`);
  });
  // v4.5 — En-tête qui se fait discret en descendant et revient en remontant.
  const siteHeader = document.querySelector('.site-header:not(.studio-header):not(.account-header)');
  if (siteHeader) {
    let lastY = scrollY;
    let ticking = false;
    const updateHeader = () => {
      const y = scrollY;
      const busy = (mobileNav && !mobileNav.hidden) || siteHeader.matches(':focus-within') || document.querySelector('[data-search-overlay]:not([hidden])');
      siteHeader.classList.toggle('is-scrolled', y > 8);
      if (busy || y < 160 || y < lastY - 4) siteHeader.classList.remove('is-hidden');
      else if (y > lastY + 4) siteHeader.classList.add('is-hidden');
      lastY = y;
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(updateHeader); } }, { passive: true });
    updateHeader();
  }

  // v4.5 — Profondeur au survol : diaporama, cartes produits et packs suivent le pointeur.
  if (matchMedia('(hover: hover) and (pointer: fine)').matches && motionOK()) {
    const depthTargets = '.hero-art, .product-card .product-visual, .pack-stage, .pack-card-visual';
    let depthNode = null;
    let depthFrame = 0;
    let depthEvent = null;
    const applyDepth = () => {
      depthFrame = 0;
      if (!depthNode || !depthEvent) return;
      const rect = depthNode.getBoundingClientRect();
      const x = Math.max(-1, Math.min(1, ((depthEvent.clientX - rect.left) / rect.width) * 2 - 1));
      const y = Math.max(-1, Math.min(1, ((depthEvent.clientY - rect.top) / rect.height) * 2 - 1));
      depthNode.style.setProperty('--px', x.toFixed(3));
      depthNode.style.setProperty('--py', y.toFixed(3));
    };
    document.addEventListener('pointermove', event => {
      const node = event.target.closest?.(depthTargets);
      if (node !== depthNode) {
        if (depthNode) { depthNode.style.setProperty('--px', '0'); depthNode.style.setProperty('--py', '0'); depthNode.classList.remove('is-tracking'); }
        depthNode = node;
        depthNode?.classList.add('is-tracking');
      }
      depthEvent = event;
      if (depthNode && !depthFrame) depthFrame = requestAnimationFrame(applyDepth);
    }, { passive: true });
    document.addEventListener('pointerleave', () => { if (depthNode) { depthNode.style.setProperty('--px', '0'); depthNode.style.setProperty('--py', '0'); depthNode.classList.remove('is-tracking'); depthNode = null; } });
  }

  // v4.5 — Manifeste : les mots s'allument au fil du défilement.
  const manifestoText = document.querySelector('.manifesto-signature p');
  if (manifestoText && motionOK() && 'IntersectionObserver' in window) {
    const wrapWords = node => {
      [...node.childNodes].forEach(child => {
        if (child.nodeType === Node.TEXT_NODE) {
          const parts = child.textContent.split(/(\s+)/);
          const fragment = document.createDocumentFragment();
          parts.forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) fragment.appendChild(document.createTextNode(part));
            else { const span = document.createElement('span'); span.className = 'mw'; span.textContent = part; fragment.appendChild(span); }
          });
          child.replaceWith(fragment);
        } else if (child.nodeType === Node.ELEMENT_NODE) wrapWords(child);
      });
    };
    wrapWords(manifestoText);
    const words = [...manifestoText.querySelectorAll('.mw')];
    manifestoText.classList.add('is-split');
    let active = false;
    let frame = 0;
    const paint = () => {
      frame = 0;
      const rect = manifestoText.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight * 0.88 - rect.top) / (innerHeight * 0.5 + rect.height * 0.6)));
      const lit = Math.round(progress * words.length);
      words.forEach((word, index) => word.classList.toggle('is-lit', index < lit));
    };
    new IntersectionObserver(entries => { active = entries[0].isIntersecting; if (active) paint(); }).observe(manifestoText);
    addEventListener('scroll', () => { if (active && !frame) frame = requestAnimationFrame(paint); }, { passive: true });
  }
  // Sélecteur pays / langue de l'en-tête : fermeture au clic extérieur et avec Échap.
  // Barre pays et langue du pied de page : le bouton s'active dès qu'un choix change.
  document.querySelectorAll('.loc-capsule__form').forEach(form => {
    const selects = [...form.querySelectorAll('select')];
    const initial = selects.map(select => select.value);
    form.classList.add('is-ready');
    form.addEventListener('change', () => form.classList.toggle('is-changed', selects.some((select, i) => select.value !== initial[i])));
  });
  document.querySelectorAll('[data-localization-popover]').forEach(popover => {
    document.addEventListener('click', event => { if (popover.open && !popover.contains(event.target)) popover.open = false; });
    popover.addEventListener('keydown', event => {
      if (event.key === 'Escape' && popover.open) { popover.open = false; popover.querySelector('summary')?.focus(); }
    });
  });

  // Suggestion de langue : langue du navigateur publiée sur la boutique et différente de la langue affichée.
  const languageSuggest = document.querySelector('[data-language-suggest]');
  if (languageSuggest) {
    const prompts = {
      fr: ['Voir le site en français ?', 'Oui', 'Non merci'],
      en: ['View this site in English?', 'Yes', 'No thanks'],
      de: ['Diese Seite auf Deutsch ansehen?', 'Ja', 'Nein, danke'],
      es: ['¿Ver este sitio en español?', 'Sí', 'No, gracias'],
      it: ['Vuoi vedere il sito in italiano?', 'Sì', 'No, grazie'],
      pl: ['Wyświetlić stronę po polsku?', 'Tak', 'Nie, dziękuję']
    };
    const storageKey = 'deno-language-suggest';
    let dismissed = false;
    try { dismissed = localStorage.getItem(storageKey) === '1'; } catch (error) { dismissed = false; }
    let available = [];
    try { available = JSON.parse(languageSuggest.querySelector('[data-language-suggest-list]')?.textContent || '[]'); } catch (error) { available = []; }
    const current = lang.slice(0, 2).toLowerCase();
    let target = null;
    if (!dismissed && available.length > 1) {
      for (const raw of (navigator.languages?.length ? navigator.languages : [navigator.language || ''])) {
        const code = String(raw).slice(0, 2).toLowerCase();
        if (code === current) break;
        const match = available.find(isoCode => String(isoCode).slice(0, 2).toLowerCase() === code);
        if (match && prompts[code]) { target = { code, isoCode: match }; break; }
      }
    }
    if (target) {
      const [question, yes, no] = prompts[target.code];
      languageSuggest.lang = target.code;
      languageSuggest.setAttribute('aria-label', question);
      languageSuggest.querySelector('[data-language-suggest-code]').value = target.isoCode;
      languageSuggest.querySelector('[data-language-suggest-text]').textContent = question;
      languageSuggest.querySelector('[data-language-suggest-yes]').textContent = yes;
      languageSuggest.querySelector('[data-language-suggest-no]').textContent = no;
      const hideSuggest = () => {
        try { localStorage.setItem(storageKey, '1'); } catch (error) { /* stockage indisponible : la carte reviendra à la prochaine visite */ }
        languageSuggest.hidden = true;
      };
      languageSuggest.querySelector('[data-language-suggest-no]').addEventListener('click', hideSuggest);
      languageSuggest.addEventListener('keydown', event => { if (event.key === 'Escape') hideSuggest(); });
      setTimeout(() => { languageSuggest.hidden = false; }, 1200);
    }
  }
})();
